<template>
  <v-data-table :headers="headers" :items="value" hide-actions>
    <template #items="{ item }">
      <td>{{ $t(item.dow) }}</td>
      <td>{{ item.start }}&ndash;{{ item.end }}</td>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      headers: [
        { text: this.$t('day_of_week'), value: 'dow', sortable: false },
        { text: this.$t('Time'), value: 'start', sortable: false }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/intent/IntentScheduleTable.vue